<template>
  <v-card>

    <v-progress-circular v-if="loading"
                         indeterminate
                         color="primary">
    </v-progress-circular>

    <v-card-text>
      <corporation-properties-view v-if="corporation != null"
                                   :corporation="corporation">
      <template v-slot:append>
        <entity-properties-row>
          <v-btn v-if="$featurePermissions.corporationCRUD"
                 tile
                 color="primary"
                 @click="openEditDialog">
            {{ $t('actions.modify') }}
            <v-icon right dark>
              mdi-border-color
            </v-icon>
          </v-btn>
        </entity-properties-row>
      </template>
      </corporation-properties-view>
      <corporation-dialog ref="corporationDialog" @done="reload"/>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue';
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import CorporationsService from '@/services/CorporationsService';
import CorporationDialog from '@/views/corporations/CorporationDialog';
import CorporationPropertiesView from '@/views/corporations/CorporationPropertiesView';

export default Vue.extend({
  name: 'CorporationDetails',
  components: {
    CorporationDialog,
    CorporationPropertiesView,
    EntityPropertiesRow,
  },
  data() {
    return {
      corporation: null,
      documents: [],
      loading: false,

    };
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      CorporationsService.get(this.corporationId).then(result => {
        this.corporation = result.data;
      }).catch(err => {
        console.log(JSON.stringify(err));
      }).finally(() => {
        this.loading = false;
      });
    },

    openEditDialog() {
      this.$refs.corporationDialog.openEditForCorporation(this.corporationId);
    },
  },

  computed: {
    corporationId() {
      return parseInt(this.$route.params.id, 10);
    },
  },
});
</script>
